// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7258587f","836":"e1a79cf0"}[chunkId] + ".chunk.js";
};